/* MavoStudio – Fliesenwürfel-Konfigurator (sections/mavo-wuerfel-konfigurator.liquid)
   5 Schritte mit Zurück/Weiter, 3D-Vorschau (assets/mavo-wuerfel-3d.js), Übersicht mit Richtpreis,
   Anfragekorb wie ein Warenkorb (Menge, Lieferland, Versand, Summe) und Anfrage über das Shopify-Kontaktformular. */
(() => {
  const root = document.querySelector('[data-mavo-cube]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  let cfg;
  try { cfg = JSON.parse(root.querySelector('[data-mavo-cube-config]').textContent); } catch (e) { return; }

  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => [...el.querySelectorAll(sel)];
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const slug = (s) => String(s).toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const store = (type) => { try { return window[type]; } catch (e) { return null; } };
  const read = (type, k, fallback) => { try { const v = store(type).getItem(k); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; } };
  const write = (type, k, v) => { try { store(type).setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } };
  const num = (v) => { const n = parseFloat(String(v == null ? '' : v).replace(/[^\d,.]/g, '').replace(',', '.')); return Number.isFinite(n) && n > 0 ? n : null; };
  const money = (n) => n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  const euro = (n) => (Number.isInteger(n) ? `${n} €` : money(n));

  // Farblisten: eine Zeile pro Farbe „Name | #Farbcode | Hinweis (optional)“
  const parseList = (text) => String(text || '').split(/\r?\n|<br\s*\/?>/).map((line) => {
    const [name, code, note] = line.split('|').map((x) => (x || '').trim());
    let hex = (code || '').toLowerCase();
    if (/^#[0-9a-f]{3}$/.test(hex)) hex = '#' + hex.slice(1).split('').map((c) => c + c).join('');
    return name && /^#[0-9a-f]{6}$/.test(hex) ? { name, hex, note: note || '' } : null;
  }).filter(Boolean);
  const palettes = {};
  const tileInfo = {};
  Object.keys(cfg.tiles).forEach((size) => {
    const t = cfg.tiles[size], list = parseList(t.colors);
    if (list.length) palettes[size] = list;
    if (list.length) tileInfo[size] = { size: Number(size), label: t.label, gloss: t.finish === 'gloss', finish: t.finishLabel };
  });
  const grouts = parseList(cfg.grout);
  const models = (cfg.models || []).map((m) => {
    const w = Number(m.w) || 30, d = Number(m.d) || w, h = Number(m.h) || 30;
    const tiles = ['15', '10'].filter((s) => m['t' + s] && palettes[s] && [w, d, h].every((x) => x % Number(s) === 0));
    return { key: slug(m.label || h) || String(h), label: m.label || `Würfel ${h}`, w, d, h, price: num(m.price), hint: m.hint || '', tiles };
  }).filter((m) => m.tiles.length);
  if (!models.length || !grouts.length) return;
  const shipping = String(cfg.shipping || '').split(/\r?\n/).map((line) => {
    const [name, price] = line.split('|').map((x) => (x || '').trim());
    return name ? { name, price: num(price) } : null;
  }).filter(Boolean);
  shipping.push({ name: 'Anderes Land', price: null, other: true });

  const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
  const dist = (a, b) => { const x = rgb(a), y = rgb(b); return 0.3 * (x[0] - y[0]) ** 2 + 0.59 * (x[1] - y[1]) ** 2 + 0.11 * (x[2] - y[2]) ** 2; };
  const usable = (list) => list.filter((c) => !c.note);
  const nearest = (list, hex) => usable(list).reduce((best, c) => (dist(c.hex, hex) < dist(best.hex, hex) ? c : best), usable(list)[0] || list[0]);
  const byName = (list, name) => list.find((c) => c.name.toLowerCase() === String(name || '').toLowerCase());
  // „Weiß matt“ ↔ „Weiß“: gleiche Farbe in der anderen Fliesengröße
  const base = (name) => String(name || '').toLowerCase().replace(/\s+(matt|glänzend|glanz)$/, '').trim();
  const byBase = (list, name) => (name ? list.find((c) => base(c.name) === base(name)) : null);
  const priceText = (m) => (m.price ? euro(m.price) : 'Preis auf Anfrage');
  const tileText = (m) => (m.tiles.length > 1 ? m.tiles.map((s) => tileInfo[s].label).join(' & ') : `nur ${tileInfo[m.tiles[0]].label}`);
  const dims = (m) => `${m.w} × ${m.d} × ${m.h} cm`;

  // ---------- Zustand ----------
  let state = null;
  let slot = 1;
  let step = 0;
  let editIndex = null;
  function resolve(next, prev) {
    const model = models.find((m) => m.key === next.model) || models.find((m) => m.key === slug(cfg.start.model)) || models[0];
    const tile = model.tiles.includes(String(next.tile)) ? String(next.tile) : model.tiles[0];
    const pal = palettes[tile];
    const pick = (name, prevColor, startName, fallbackIndex) =>
      byName(pal, name) || byBase(pal, name) || (prevColor ? nearest(pal, prevColor.hex) : null) || byName(pal, startName) || usable(pal)[fallbackIndex] || pal[0];
    const c1 = pick(next.c1, prev && prev.c1, cfg.start.color, 0);
    const c2 = pick(next.c2, prev && prev.c2, cfg.start.color2, 1);
    const grout = byName(grouts, next.grout) || (prev ? prev.grout : null) || byName(grouts, cfg.start.grout) || grouts[0];
    return { model, tile, pattern: next.pattern === 'kariert' ? 'kariert' : 'einfarbig', c1, c2, grout };
  }
  const names = (s) => ({ model: s.model.key, tile: s.tile, pattern: s.pattern, c1: s.c1.name, c2: s.c2.name, grout: s.grout.name });
  const listeners = new Set();
  // Wechsel der Fliesengröße: nur hin und her geschaltet → eigene Wahl zurückholen, sonst die ähnlichsten Farben
  const memo = {};
  let autoColors = false;
  function update(patch) {
    const before = state, picked = 'c1' in patch || 'c2' in patch;
    let next = resolve({ ...names(state), ...patch }, state);
    if (next.tile !== before.tile && !picked) {
      if (autoColors && memo[next.tile]) next = resolve({ ...names(next), ...memo[next.tile] }, null);
      if (!autoColors) memo[before.tile] = { c1: before.c1.name, c2: before.c2.name };
      autoColors = true;
    } else if (picked) autoColors = false;
    state = next;
    root.dataset.touched = '1';
    write('sessionStorage', 'mavo-cube-state', names(state));
    render();
    listeners.forEach((fn) => fn());
  }

  const params = new URLSearchParams(location.search);
  const fromUrl = params.get('wuerfel') ? {
    model: params.get('wuerfel'), tile: params.get('fliese'), pattern: params.get('muster'),
    c1: params.get('farbe'), c2: params.get('farbe2'), grout: params.get('fuge'),
  } : null;
  state = resolve(fromUrl || read('sessionStorage', 'mavo-cube-state', null) || { pattern: cfg.start.pattern }, null);

  const shareUrl = (s = state) => {
    const q = new URLSearchParams({ wuerfel: s.model.key, fliese: s.tile, muster: s.pattern, farbe: s.c1.name });
    if (s.pattern === 'kariert') q.set('farbe2', s.c2.name);
    q.set('fuge', s.grout.name);
    return `${location.origin}${location.pathname}?${q}`;
  };
  const colorText = (s) => (s.pattern === 'kariert' ? `${s.c1.name} & ${s.c2.name}` : s.c1.name);
  const chip = (c) => `<span class="mavo-cube__chip" style="--c:${c.hex}" aria-hidden="true"></span>${esc(c.name)}`;

  // ---------- Schritte ----------
  const STEPS = [
    { label: 'Größe', title: 'Würfel wählen', sub: 'Größe und Richtpreis auswählen.' },
    { label: 'Fliesen', title: 'Fliesen wählen', sub: Object.keys(tileInfo).sort((a, b) => b - a).map((s) => `${tileInfo[s].label} ${tileInfo[s].finish}`).join(' oder ') + '?' },
    { label: 'Muster', title: 'Muster wählen', sub: 'Einfarbig oder kariert?' },
    { label: 'Farbe', title: 'Fliesenfarbe wählen', sub: '' },
    { label: 'Fuge', title: 'Fugenfarbe wählen', sub: 'Sie rahmt jede Fliese ein – hell, dunkel oder bunt.' },
  ];
  const ICON_CHECK = '<svg class="mavo-cube__tick" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 8.4l2.9 2.9 6.1-6.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const silhouette = (m) => {
    const s = 15, lines = [];
    for (let y = s; y < m.h; y += s) lines.push(`<line x1="0" y1="${m.h - y}" x2="${m.w}" y2="${m.h - y}"/>`);
    for (let x = s; x < m.w; x += s) lines.push(`<line x1="${x}" y1="0" x2="${x}" y2="${m.h}"/>`);
    return `<svg class="mavo-cube__sil" viewBox="0 0 ${m.w} 60" aria-hidden="true" focusable="false"><g transform="translate(0 ${60 - m.h})"><rect x="0.6" y="0.6" width="${m.w - 1.2}" height="${m.h - 1.2}" rx="1.4"/>${lines.join('')}</g></svg>`;
  };
  const progress = $('[data-progress]');
  progress.innerHTML = STEPS.map((st, i) => `
    <li><button type="button" class="mavo-cube__pstep" data-goto="${i}">
      <span class="mavo-cube__pnum"><span>${i + 1}</span>${ICON_CHECK}</span><span class="mavo-cube__plabel">${st.label}</span>
    </button></li>`).join('');

  const steps = $('[data-steps]');
  const panelHead = (i) => `<h2 class="mavo-cube__steptitle" id="MavoCubeStep${i}" tabindex="-1">${STEPS[i].title}</h2><p class="mavo-cube__stepsub" data-sub="${i}">${esc(STEPS[i].sub)}</p>`;
  steps.innerHTML = `
    <section class="mavo-cube__panelstep" data-panel="0" aria-labelledby="MavoCubeStep0">
      ${panelHead(0)}
      <div class="mavo-cube__grid2" role="radiogroup" aria-labelledby="MavoCubeStep0">
        ${models.map((m) => `
          <label class="mavo-cube__opt mavo-cube__opt--model" data-model="${esc(m.key)}">
            <input class="visually-hidden" type="radio" name="mavo-cube-model" value="${esc(m.key)}">
            ${silhouette(m)}
            <span class="mavo-cube__opttitle">${esc(m.label)}</span>
            <span class="mavo-cube__optsub">${dims(m)}</span>
            ${m.hint ? `<span class="mavo-cube__opthint">${esc(m.hint)}</span>` : ''}
            <span class="mavo-cube__optmeta">${esc(tileText(m))}</span>
            <span class="mavo-cube__optprice">${esc(priceText(m))}</span>${ICON_CHECK}
          </label>`).join('')}
      </div>
    </section>
    <section class="mavo-cube__panelstep" data-panel="1" aria-labelledby="MavoCubeStep1" hidden>
      ${panelHead(1)}
      <div class="mavo-cube__grid2" role="radiogroup" aria-labelledby="MavoCubeStep1">
        ${Object.keys(tileInfo).sort((a, b) => b - a).map((size) => `
          <label class="mavo-cube__opt" data-tile="${size}">
            <input class="visually-hidden" type="radio" name="mavo-cube-tile" value="${size}">
            <span class="mavo-cube__tileicon mavo-cube__tileicon--${size}${tileInfo[size].gloss ? ' is-gloss' : ''}" aria-hidden="true"></span>
            <span class="mavo-cube__opttitle">${esc(tileInfo[size].label)}</span>
            <span class="mavo-cube__optsub">${esc(tileInfo[size].finish)} · ${usable(palettes[size]).length} Farben</span>
            <span class="mavo-cube__optnote" data-tile-note></span>${ICON_CHECK}
          </label>`).join('')}
      </div>
    </section>
    <section class="mavo-cube__panelstep" data-panel="2" aria-labelledby="MavoCubeStep2" hidden>
      ${panelHead(2)}
      <div class="mavo-cube__grid2" role="radiogroup" aria-labelledby="MavoCubeStep2">
        ${[['einfarbig', 'Einfarbig', 'Eine Farbe für alle Fliesen'], ['kariert', 'Kariert', 'Zwei Farben im Wechsel']].map(([v, t, sub]) => `
          <label class="mavo-cube__opt" data-pattern="${v}">
            <input class="visually-hidden" type="radio" name="mavo-cube-pattern" value="${v}">
            <span class="mavo-cube__patternicon mavo-cube__patternicon--${v}" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i></span>
            <span class="mavo-cube__opttitle">${t}</span>
            <span class="mavo-cube__optsub">${sub}</span>${ICON_CHECK}
          </label>`).join('')}
      </div>
    </section>
    <section class="mavo-cube__panelstep" data-panel="3" aria-labelledby="MavoCubeStep3" hidden>
      ${panelHead(3)}
      <div class="mavo-cube__slots" data-slots>
        ${[1, 2].map((n) => `
          <button type="button" class="mavo-cube__slot" data-slot="${n}" aria-pressed="false">
            <span class="mavo-cube__slotdot" aria-hidden="true"></span>
            <span class="mavo-cube__slottext"><span class="mavo-cube__slotlabel">Farbe ${n}</span><span class="mavo-cube__slotname" data-slot-name></span></span>
          </button>`).join('')}
      </div>
      <div class="mavo-cube__swatches" data-colors role="group" aria-labelledby="MavoCubeStep3"></div>
      ${cfg.colorNote ? `<p class="mavo-cube__notebox">${esc(cfg.colorNote)}</p>` : ''}
    </section>
    <section class="mavo-cube__panelstep" data-panel="4" aria-labelledby="MavoCubeStep4" hidden>
      ${panelHead(4)}
      <div class="mavo-cube__swatches mavo-cube__swatches--grout" role="group" aria-labelledby="MavoCubeStep4">
        ${grouts.map((g) => `
          <button type="button" class="mavo-cube__swatch mavo-cube__swatch--grout" data-grout="${esc(g.name)}" aria-pressed="false"${g.note ? ' disabled' : ''}>
            <span class="mavo-cube__dot" style="--c:${g.hex}" aria-hidden="true"></span><span class="mavo-cube__swatchname">${esc(g.name)}</span>
            ${g.note ? `<span class="mavo-cube__soldout">${esc(g.note)}</span>` : ''}
          </button>`).join('')}
      </div>
    </section>`;

  let colorsFor = '';
  function renderColors() {
    if (colorsFor === state.tile) return;
    colorsFor = state.tile;
    const gloss = tileInfo[state.tile].gloss;
    $('[data-colors]').innerHTML = palettes[state.tile].map((c) => `
      <button type="button" class="mavo-cube__swatch" data-color="${esc(c.name)}" aria-pressed="false"${c.note ? ' disabled' : ''}>
        <span class="mavo-cube__dot mavo-cube__dot--tile${gloss ? ' is-gloss' : ''}" style="--c:${c.hex}" aria-hidden="true"><span class="mavo-cube__badges"></span></span>
        <span class="mavo-cube__swatchname">${esc(c.name)}</span>
        ${c.note ? `<span class="mavo-cube__soldout">${esc(c.note)}</span>` : ''}
      </button>`).join('');
  }

  // 2D-Vorschau (bis 3D geladen ist oder falls der Browser kein 3D kann): Vorderseite
  const flat = $('[data-mavo-cube-flat]');
  function renderFlat() {
    const { model: m, tile } = state, s = Number(tile), cols = m.w / s, rows = m.h / s;
    let cells = '';
    for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) {
      cells += `<i style="background:${state.pattern === 'kariert' && (r + c) % 2 ? state.c2.hex : state.c1.hex}"></i>`;
    }
    flat.style.cssText = `--cols:${cols};--rows:${rows};--grout:${state.grout.hex};--ratio:${m.w}/${m.h};--scale:${(m.h + 60) / 2 / 60}`;
    flat.innerHTML = `<div class="mavo-cube__flatface">${cells}</div>`;
  }

  const lastStep = STEPS.length - 1;
  function renderStep() {
    $$('[data-panel]').forEach((p) => { p.hidden = Number(p.dataset.panel) !== step; });
    $$('[data-goto]').forEach((b) => {
      const i = Number(b.dataset.goto);
      b.classList.toggle('is-current', i === step);
      b.classList.toggle('is-done', i < step);
      if (i === step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
    $('[data-prev]').disabled = step === 0;
    $('[data-next-label]').textContent = step === lastStep ? (editIndex != null ? 'Änderung übernehmen' : 'In den Anfragekorb') : 'Weiter';
  }

  function render() {
    const s = state, checker = s.pattern === 'kariert';
    renderColors();
    $$('[data-model]').forEach((el) => {
      const on = el.dataset.model === s.model.key;
      el.classList.toggle('is-active', on);
      el.querySelector('input').checked = on;
    });
    $$('[data-tile]').forEach((el) => {
      const ok = s.model.tiles.includes(el.dataset.tile), on = el.dataset.tile === s.tile;
      el.classList.toggle('is-active', on);
      el.classList.toggle('is-disabled', !ok);
      const input = el.querySelector('input');
      input.checked = on; input.disabled = !ok;
      const fits = [s.model.w, s.model.d, s.model.h].every((x) => x % Number(el.dataset.tile) === 0);
      el.querySelector('[data-tile-note]').textContent = ok ? '' : fits ? `Für ${s.model.label} nicht erhältlich` : `Passt nicht zu ${s.model.h} cm Höhe`;
    });
    $$('[data-pattern]').forEach((el) => {
      const on = el.dataset.pattern === s.pattern;
      el.classList.toggle('is-active', on);
      el.querySelector('input').checked = on;
    });
    if (!checker) slot = 1;
    $('[data-slots]').hidden = !checker;
    $('[data-sub="3"]').textContent = checker
      ? `Zwei Farben im Wechsel – wähle jetzt Farbe ${slot}.`
      : `${usable(palettes[s.tile]).length} Farben, ${tileInfo[s.tile].finish}.`;
    $$('[data-slot]').forEach((b) => {
      const n = Number(b.dataset.slot), c = n === 1 ? s.c1 : s.c2, on = n === slot;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
      b.querySelector('.mavo-cube__slotdot').style.setProperty('--c', c.hex);
      b.querySelector('[data-slot-name]').textContent = c.name;
    });
    $$('[data-color]').forEach((b) => {
      const n = b.dataset.color, used1 = n === s.c1.name, used2 = checker && n === s.c2.name;
      b.classList.toggle('is-current', checker ? (slot === 1 ? used1 : used2) : used1);
      b.classList.toggle('is-used', used1 || used2);
      b.setAttribute('aria-pressed', used1 || used2);
      b.querySelector('.mavo-cube__badges').innerHTML = checker ? (used1 ? '<span>1</span>' : '') + (used2 ? '<span>2</span>' : '') : '';
    });
    $$('[data-grout]').forEach((b) => {
      const on = b.dataset.grout === s.grout.name;
      b.classList.toggle('is-current', on);
      b.setAttribute('aria-pressed', on);
    });
    $('[data-summary]').innerHTML = [
      ['Größe', `${esc(s.model.label)} · ${dims(s.model)}`],
      ['Fliesen', `${esc(tileInfo[s.tile].label)}, ${esc(tileInfo[s.tile].finish)}`],
      ['Muster', checker ? 'Kariert' : 'Einfarbig'],
      [checker ? 'Farben' : 'Farbe', checker ? `${chip(s.c1)} ${chip(s.c2)}` : chip(s.c1)],
      ['Fuge', chip(s.grout)],
    ].map(([k, v]) => `<div><dt>${k}</dt><dd>${v}</dd></div>`).join('');
    $('[data-price]').textContent = priceText(s.model);
    $('[data-add-label]').textContent = editIndex != null ? 'Änderung übernehmen' : 'In den Anfragekorb';
    renderFlat();
    renderStep();
    if (fromUrl || root.dataset.touched) {
      try { history.replaceState(history.state, '', `${location.pathname}?${shareUrl(s).split('?')[1]}${location.hash}`); } catch (e) {}
    }
  }

  function goTo(i, focus) {
    step = Math.max(0, Math.min(lastStep, i));
    renderStep();
    const head = $(`#MavoCubeStep${step}`);
    const top = steps.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.8) $('[data-progress]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (focus && head) head.focus({ preventScroll: true });
  }

  // ---------- Bedienung ----------
  steps.addEventListener('change', (e) => {
    const t = e.target;
    if (t.name === 'mavo-cube-model') {
      const prevTile = state.tile;
      update({ model: t.value });
      if (state.tile !== prevTile) toast(`${state.model.label} gibt es mit ${tileInfo[state.tile].label} – wir haben die Fliesen angepasst.`);
    }
    if (t.name === 'mavo-cube-tile') update({ tile: t.value });
    if (t.name === 'mavo-cube-pattern') { slot = 1; update({ pattern: t.value }); }
  });
  steps.addEventListener('click', (e) => {
    const sl = e.target.closest('[data-slot]');
    if (sl) { slot = Number(sl.dataset.slot); render(); return; }
    const c = e.target.closest('[data-color]');
    if (c) {
      if (state.pattern === 'kariert') {
        const other = slot === 1 ? state.c2.name : state.c1.name;
        const patch = slot === 1 ? { c1: c.dataset.color } : { c2: c.dataset.color };
        // gleiche Farbe auf beiden Feldern → tauschen statt doppelt
        if (c.dataset.color === other) Object.assign(patch, slot === 1 ? { c2: state.c1.name } : { c1: state.c2.name });
        const was = slot;
        update(patch);
        if (was === 1) { slot = 2; render(); }
      } else update({ c1: c.dataset.color });
      return;
    }
    const g = e.target.closest('[data-grout]');
    if (g) update({ grout: g.dataset.grout });
  });
  progress.addEventListener('click', (e) => {
    const b = e.target.closest('[data-goto]');
    if (b) goTo(Number(b.dataset.goto), true);
  });
  $('[data-prev]').addEventListener('click', () => goTo(step - 1, true));
  $('[data-next]').addEventListener('click', () => { if (step === lastStep) addToCart(); else goTo(step + 1, true); });
  $('[data-add]').addEventListener('click', () => addToCart());

  const toastEl = $('[data-mavo-cube-toast]');
  let toastTimer = 0;
  function toast(text) {
    if (!toastEl) return;
    toastEl.textContent = text;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.hidden = true; }, 4200);
  }

  // Zufällige Kombi
  root.addEventListener('click', (e) => {
    if (!e.target.closest('[data-mavo-cube-random]')) return;
    const pal = usable(palettes[state.tile]), pickOne = (list) => list[Math.floor(Math.random() * list.length)];
    const c1 = pickOne(pal);
    let c2 = pickOne(pal);
    while (pal.length > 1 && c2 === c1) c2 = pickOne(pal);
    update({ pattern: Math.random() < 0.5 ? 'kariert' : 'einfarbig', c1: c1.name, c2: c2.name, grout: pickOne(usable(grouts)).name });
  });

  // Link teilen
  const flash = (btn, text) => {
    const label = btn.querySelector('span') || btn, before = label.textContent;
    label.textContent = text; btn.classList.add('is-done');
    setTimeout(() => { label.textContent = before; btn.classList.remove('is-done'); }, 2200);
  };
  $('[data-share]').addEventListener('click', (e) => {
    const btn = e.currentTarget, url = shareUrl();
    const fallback = () => {
      const t = document.createElement('textarea');
      t.value = url; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(t); t.select();
      let ok = false; try { ok = document.execCommand('copy'); } catch (err) {}
      t.remove(); flash(btn, ok ? 'Link kopiert' : 'Kopieren nicht möglich');
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(url).then(() => flash(btn, 'Link kopiert'), fallback);
    else fallback();
  });

  // ---------- Anfragekorb ----------
  const CART = 'mavo-cube-anfragekorb';
  const drawer = $('[data-cart]');
  const pill = $('[data-cart-open]');
  let cart = read('localStorage', CART, []).filter((i) => i && i.cfg);
  let country = read('localStorage', 'mavo-cube-land', shipping[0].name);
  let viewer = null;
  const saveCart = () => {
    if (!write('localStorage', CART, cart)) write('localStorage', CART, cart.map((i) => ({ ...i, thumb: '' })));
  };
  const mini = (s) => {
    const n = Number(s.tile) === 10 ? 3 : 2;
    let cells = '';
    for (let i = 0; i < n * n; i++) cells += `<i style="background:${s.pattern === 'kariert' && ((i % n) + Math.floor(i / n)) % 2 ? s.c2.hex : s.c1.hex}"></i>`;
    return `<span class="mavo-cube__mini" style="--n:${n};--grout:${s.grout.hex}" aria-hidden="true">${cells}</span>`;
  };
  const describe = (s) => `${s.model.label} (${dims(s.model)}) · ${tileInfo[s.tile].label} ${tileInfo[s.tile].finish} · ${s.pattern === 'kariert' ? 'Kariert' : 'Einfarbig'}: ${colorText(s)} · Fuge ${s.grout.name}`;
  function totals() {
    let sub = 0, open = false, qty = 0;
    cart.forEach((i) => { const s = resolve(i.cfg, null); qty += i.qty; if (s.model.price) sub += s.model.price * i.qty; else open = true; });
    const land = shipping.find((x) => x.name === country) || shipping[0];
    const ship = land.price != null ? land.price * qty : null;
    return { sub, open, qty, land, ship, sum: sub + (ship || 0), sumOpen: open || ship == null };
  }
  function renderCart() {
    const list = $('[data-cart-items]'), count = cart.reduce((n, i) => n + i.qty, 0);
    pill.hidden = !count || drawer.open;
    $('[data-cart-count]').textContent = count;
    $('[data-cart-heading-count]').textContent = count ? `· ${count} Würfel` : '';
    $('[data-cart-empty]').hidden = !!count;
    $('[data-cart-checkout]').hidden = !count;
    list.innerHTML = cart.map((i, idx) => {
      const s = resolve(i.cfg, null), price = s.model.price;
      return `<li class="mavo-cube__item">
        <span class="mavo-cube__thumb">${i.thumb ? `<img src="${i.thumb}" alt="" width="88" height="88">` : mini(s)}</span>
        <div class="mavo-cube__iteminfo">
          <p class="mavo-cube__itemtitle">${esc(s.model.label)} · ${esc(colorText(s))}</p>
          <p class="mavo-cube__itemprops">${dims(s.model)} · ${esc(tileInfo[s.tile].label)} ${esc(tileInfo[s.tile].finish)}<br>Muster: ${s.pattern === 'kariert' ? 'Kariert' : 'Einfarbig'} · Fuge: ${esc(s.grout.name)}</p>
          <p class="mavo-cube__itemunit">${price ? `${money(price)} / Stück` : 'Preis auf Anfrage'}</p>
          <div class="mavo-cube__itemlinks">
            <button type="button" class="mavo-cube__textbtn" data-edit="${idx}">Bearbeiten</button>
            <button type="button" class="mavo-cube__textbtn" data-remove="${idx}">Entfernen</button>
          </div>
        </div>
        <div class="mavo-cube__itemside">
          <div class="mavo-cube__qty" role="group" aria-label="Menge">
            <button type="button" data-qty="${idx}" data-step="-1" aria-label="Weniger"${i.qty <= 1 ? ' disabled' : ''}>−</button>
            <span aria-live="polite">${i.qty}</span>
            <button type="button" data-qty="${idx}" data-step="1" aria-label="Mehr"${i.qty >= 10 ? ' disabled' : ''}>+</button>
          </div>
          <p class="mavo-cube__itemtotal">${price ? money(price * i.qty) : '–'}</p>
        </div>
      </li>`;
    }).join('');
    const sel = $('[data-country]');
    if (!sel.options.length) sel.innerHTML = shipping.map((x) => `<option value="${esc(x.name)}">${esc(x.name)}</option>`).join('');
    sel.value = (shipping.find((x) => x.name === country) || shipping[0]).name;
    const t = totals();
    $('[data-cart-sums]').innerHTML = `
      <div><dt>Zwischensumme</dt><dd>${money(t.sub)}${t.open ? ' + Preis auf Anfrage' : ''}</dd></div>
      <div><dt>Versand<small>${t.land.price != null ? `${esc(t.land.name)}: ${money(t.land.price)} × ${t.qty} Würfel` : 'Kosten bekommst du mit unserer Antwort'}</small></dt><dd>${t.ship != null ? money(t.ship) : 'auf Anfrage'}</dd></div>
      <div class="is-sum"><dt>Summe</dt><dd>${t.sumOpen ? 'ab ' : ''}${money(t.sum)}</dd></div>`;
    renderFormFields();
  }
  function renderFormFields() {
    const box = $('[data-cart-fields]'), sum = $('[data-form-summary]');
    if (!box) return;
    const t = totals();
    let html = '';
    cart.forEach((i, idx) => {
      const s = resolve(i.cfg, null), price = s.model.price;
      html += `<input type="hidden" name="contact[Würfel ${idx + 1}]" value="${esc(`${describe(s)} · Menge ${i.qty}${price ? ` · ${money(price)} je Stück` : ' · Preis auf Anfrage'}`)}">`;
      html += `<input type="hidden" name="contact[Würfel ${idx + 1} Link]" value="${esc(shareUrl(s))}">`;
    });
    html += `<input type="hidden" name="contact[Lieferland]" value="${esc(t.land.name)}">`;
    html += `<input type="hidden" name="contact[Versand]" value="${esc(t.ship != null ? `${money(t.ship)} (${money(t.land.price)} × ${t.qty} Würfel)` : 'auf Anfrage')}">`;
    html += `<input type="hidden" name="contact[Summe Richtwert]" value="${esc(`${t.sumOpen ? 'ab ' : ''}${money(t.sum)}`)}">`;
    box.innerHTML = html;
    if (sum) sum.innerHTML = `<span>${t.qty} Würfel · ${esc(t.land.name)}</span><strong>${t.sumOpen ? 'ab ' : ''}${money(t.sum)}</strong>`;
  }
  function showPane(name) {
    $$('[data-pane]', drawer).forEach((p) => { p.hidden = p.dataset.pane !== name; });
    const body = $(`[data-pane="${name}"]`, drawer);
    if (body) body.scrollTop = 0;
  }
  function openCart(pane = 'cart') {
    renderCart();
    showPane(pane);
    if (!drawer.open) {
      if (typeof drawer.showModal === 'function') drawer.showModal(); else drawer.setAttribute('open', '');
    }
    document.documentElement.classList.add('mavo-cube-lock');
    pill.hidden = true;
  }
  function closeCart() {
    if (drawer.open) { if (typeof drawer.close === 'function') drawer.close(); else drawer.removeAttribute('open'); }
  }
  drawer.addEventListener('close', () => { document.documentElement.classList.remove('mavo-cube-lock'); renderCart(); });
  drawer.addEventListener('click', (e) => {
    if (e.target === drawer) { closeCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    if (e.target.closest('[data-to-form]')) { if (cart.length) { renderFormFields(); showPane('form'); if (window.matchMedia('(pointer: fine)').matches) setTimeout(() => { const f = $('#MavoCubeName'); if (f && !f.value) f.focus(); }, 50); } return; }
    if (e.target.closest('[data-to-cart]')) { showPane('cart'); return; }
    const q = e.target.closest('[data-qty]');
    if (q) { const it = cart[Number(q.dataset.qty)]; if (it) { it.qty = Math.max(1, Math.min(10, it.qty + Number(q.dataset.step))); saveCart(); renderCart(); } return; }
    const rm = e.target.closest('[data-remove]');
    if (rm) { cart.splice(Number(rm.dataset.remove), 1); saveCart(); renderCart(); return; }
    const ed = e.target.closest('[data-edit]');
    if (ed) {
      const idx = Number(ed.dataset.edit), it = cart[idx];
      if (!it) return;
      editIndex = idx; slot = 1;
      closeCart();
      update(it.cfg);
      goTo(0, false);
      root.querySelector('[data-mavo-cube-stage]').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  $('[data-country]').addEventListener('change', (e) => { country = e.target.value; write('localStorage', 'mavo-cube-land', country); renderCart(); });
  pill.addEventListener('click', () => openCart('cart'));

  function addToCart() {
    const thumb = viewer && viewer.snapshot ? viewer.snapshot(240) : '';
    const entry = { cfg: names(state), qty: 1, thumb };
    if (editIndex != null && cart[editIndex]) {
      entry.qty = cart[editIndex].qty;
      cart[editIndex] = entry;
      editIndex = null;
    } else {
      const same = cart.find((i) => JSON.stringify(i.cfg) === JSON.stringify(entry.cfg));
      if (same) { same.qty = Math.min(10, same.qty + 1); if (thumb) same.thumb = thumb; } else cart.push(entry);
    }
    saveCart();
    render();
    openCart('cart');
  }

  // ---------- Anfrage abschicken ----------
  const form = document.getElementById('MavoCubeForm');
  if (form) {
    form.addEventListener('submit', () => {
      renderFormFields();
      const t = totals();
      write('sessionStorage', 'mavo-cube-sent', { items: cart.map((i) => ({ cfg: i.cfg, qty: i.qty })), sum: `${t.sumOpen ? 'ab ' : ''}${money(t.sum)}` });
    });
  }
  const success = $('[data-mavo-cube-success]');
  if (success) {
    const sent = read('sessionStorage', 'mavo-cube-sent', null);
    if (sent && sent.items) {
      $('[data-sent-list]', success).innerHTML = sent.items.map((i) => {
        const s = resolve(i.cfg, null);
        return `<li>${mini(s)}<span><strong>${i.qty} × ${esc(s.model.label)}</strong><br>${esc(colorText(s))} · Fuge ${esc(s.grout.name)}</span></li>`;
      }).join('') + `<li class="mavo-cube__sentsum"><span>Summe (Richtwert)</span><strong>${esc(sent.sum || '')}</strong></li>`;
      // erst nach erfolgreichem Absenden leeren
      cart = [];
      saveCart();
    }
    try { store('sessionStorage').removeItem('mavo-cube-sent'); } catch (err) {}
  }

  render();
  renderCart();
  if (success) { openCart('form'); requestAnimationFrame(() => success.focus({ preventScroll: true })); }
  else if ($('[data-mavo-cube-error]')) openCart('form');

  // ---------- 3D ----------
  const stageEl = $('[data-mavo-cube-stage]');
  const api = {
    getState: () => ({
      w: state.model.w, d: state.model.d, h: state.model.h, tile: Number(state.tile), gloss: tileInfo[state.tile].gloss,
      pattern: state.pattern, c1: state.c1.hex, c2: state.c2.hex, grout: state.grout.hex,
    }),
    subscribe: (fn) => listeners.add(fn),
  };
  const canWebGL = (() => {
    try { const c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl'))); } catch (e) { return false; }
  })();
  if (stageEl && canWebGL && cfg.viewer && cfg.three) {
    import(cfg.viewer)
      .then(({ mountCube3D }) => mountCube3D(stageEl, { threeUrl: cfg.three, api }))
      .then((v) => { viewer = v; if (!v) stageEl.classList.add('is-flat'); })
      .catch(() => stageEl.classList.add('is-flat'));
  } else if (stageEl) {
    stageEl.classList.add('is-flat');
  }
})();
